import { formatIN } from '../kit'

// Where the exits stand: the chain's stages in order as a track, each with the
// number of exits waiting at it. Every stage is drawn, including the ones no
// exit stands at, so a committee sees the whole road and not only where the
// traffic is. A stage holding exits is filled in the brand's soft orange with
// its count in strong ink; an empty one stays a quiet outline.

export type StageCount = { stage: string; label: string; count: number }

export function StageCounts({ stages, title }: { stages: StageCount[]; title: string }) {
  return (
    <ol className="rpt-stages" aria-label={title} style={{ ['--n' as string]: String(Math.max(stages.length, 1)) }}>
      {stages.map((s) => (
        <li key={s.stage} className={s.count > 0 ? 'on' : undefined}>
          <span className="rpt-stage-dot hc-num">{formatIN(s.count)}</span>
          <span className="rpt-stage-l">{s.label}</span>
        </li>
      ))}
    </ol>
  )
}

// Recorded of required, as a bar with the words beside it.
export function EvidenceMeter({ recorded, required }: { recorded: number; required: number }) {
  const share = required > 0 ? Math.min(1, recorded / required) : 0
  return (
    <div className="rpt-meter" role="img" aria-label={recorded + ' of ' + required + ' mandatory checklist items recorded with evidence'}>
      <span className="rpt-meter-track">
        <i style={{ width: share * 100 + '%' }} />
      </span>
      <span className="rpt-meter-words">
        <b className="hc-num">{formatIN(recorded)}</b> of <b className="hc-num">{formatIN(required)}</b> mandatory items recorded
      </span>
    </div>
  )
}
